export const BACKEND_SOURCE = {
	PROFILE: "PROFILE",
	INCOMING_LIKES: "INCOMING_LIKES",
};



// WEBPACK FOOTER //
// ./src/shared/constants/backend_source.js